<div data-testid="purchase-order-page" class="p-6 flex-table-page">
  <!-- Header -->
  <div class="page-header flex-table-header">
    <h2 class="page-title">
      {{ "purchase_order.management.title" | translate }}
    </h2>
  </div>
  <!-- Search Form -->
  <app-search-form
    data-testid="purchase-order-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'purchase-order-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAdd()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="purchase-order-table"
      #advancedTable
      [dataSource]="purchaseOrders()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Currency Columns -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "total" || column?.prop === "netTotal") {
        <span
          class="text-xs font-medium currency-amount"
          style="font-size: 12px"
        >
          {{ formatCurrency(value) }}
        </span>
      }
      @if (column?.prop === "deliveryDate") {
        <span class="text-xs font-medium" style="font-size: 12px">
          {{ formatDeliveryDate(value) }}
        </span>
      }
      @if (column?.prop === "creationDate") {
        <span class="text-xs font-medium" style="font-size: 12px">
          {{ formatDate(value) }}
        </span>
      }
      @if (column?.prop === "purchaseRequest") {
        <a
          (click)="onViewPurchaseRequest(rowData.purchaseRequest?.id)"
          class="text-blue-600 hover:text-blue-800 underline cursor-pointer text-xs font-medium"
          style="font-size: 12px"
        >
          {{ value?.series }}
        </a>
      }
      @if (column?.prop === "status") {
        <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          data-testid="purchase-order-status-tag"
          [value]="getStatusDisplayText(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(value)"
            [pTooltip]="getStatusDisplayText(value)"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </div>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          data-testid="purchase-order-status-tag-template"
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="getStatusDisplayText(status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="inline-flex items-center gap-2 whitespace-nowrap">
        <!-- View button -->
        @if (canRead()) {
          <button
            [attr.data-testid]="'purchase-order-action-view-' + rowData.id"
            type="button"
            (click)="onActionClick('view', rowData)"
            class="action-link action-view cursor-pointer"
          >
            {{ "common.actions.view" | translate }}
          </button>
        }

        <!-- Others button - only visible if there are actions available and user has permissions -->
        @if (
          getPurchaseOrderActions(rowData).length > 0 &&
          hasEnabledPurchaseOrderActions(rowData)
        ) {
          <button
            [attr.data-testid]="'purchase-order-action-others-' + rowData.id"
            type="button"
            class="action-link action-others cursor-pointer"
            aria-haspopup="menu"
            (click)="toggleMenu($event, rowData)"
          >
            {{ "common.actions.others" | translate }}
          </button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Single Menu for All Actions -->
<p-menu
  data-testid="purchase-order-actions-menu"
  #actionMenu
  [popup]="true"
  [model]="currentMenuModel()"
  appendTo="body"
  [baseZIndex]="2100"
  styleClass="actions-menu text-[0.75rem]"
  [autoZIndex]="true"
></p-menu>

<!-- Toast Messages -->
<p-toast data-testid="purchase-order-toast"></p-toast>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'purchase-order-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
